module.exports = __webpack_public_path__ + "media/images/icons/social/google-08c57b4208f02aa169b9e6135e037efc.png";